import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import styles from "./ViewFeedbackDetails.module.css";
import { useTranslation } from "react-i18next";
import DatatTable from "../../basic-component/TableNoStyle";
import Card from "react-bootstrap/Card";
import { generateAppropriateDate } from "../../basic-component/DateUtils";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
const SlaDetails = ({ data }) => {
  const { t } = useTranslation();

  // const { t } = useTranslation();
  const columnData = useMemo(
    () => [
      {
        accessorKey: "Receiver",
        header: t("feedbackDetails.step.text"),
        size: 20,
      },
      {
        accessorKey: "MasterArea",
        header: t("feedbackDetails.assignName.text"),
        size: 40,
      },
      {
        accessorKey: "TargetDate",
        header: t("menu.key.master.targettime"),
        size: 30,
      },
    ],
    [t]
  );
  const columnData1 = useMemo(
    () => [
      {
        accessorKey: "Receiver",
        header: t("general.label.escalation.step"),
        size: 20,
      },
      {
        accessorKey: "MasterArea",
        header: t("general.label.assignee.name.group"),
        size: 40,
      },
      {
        accessorKey: "SubArea",
        header: t("general.label.escalation.time"),
        size: 30,
      },
    ],
    [t]
  );
  // const generateAppropriateDate = (value) => {

  //   if (value === undefined || value === null) {
  //     return 'N/A';
  //   } else {
  //     const date = new Date(value);
  //     const formattedDate =
  //       date.toLocaleDateString('en-US', {
  //         year: 'numeric',
  //         month: '2-digit',
  //         day: '2-digit',
  //       }) +
  //       ' ' +
  //       date.toLocaleTimeString('en-US', {
  //         hour: '2-digit',
  //         minute: '2-digit',
  //       });
  //     return formattedDate;
  //   }
  // };
  const rowsData = [];
  const rowsData1 = [];
  {
    data.slaDetails.receipt.departmentSlaEscalationList &&
      data.slaDetails.receipt.departmentSlaEscalationList.length > 0 &&
      data?.slaDetails?.receipt?.departmentSlaEscalationList?.map(
        (escalationdata, index) => {
          debugger;
          rowsData1.push({
            Receiver: escalationdata.escalationStep,
            MasterArea:
              escalationdata.asigneeId !== 0 ? (
                escalationdata.assigneeName
              ) : (
                <>
                  {escalationdata.assigneeGroupName}{" "}
                  <i className="fa fa-share-square-o"></i>
                </>
              ),
            SubArea: generateAppropriateDate(escalationdata.escTime), // Assuming item is defined elsewhere
          });
        }
      );
  }

  const tableStyles = {
    width: " 100%",
    height: "auto",
    minWidth: "0",
  };

  data.slaDetails.receipt.departmentSlaAssignmentList.map(
    (optiondata, index) => {
      debugger;
      rowsData.push({
        Receiver: index + 1,
        MasterArea: optiondata.assigneeName,
        TargetDate: generateAppropriateDate(optiondata.targetTime),
      });
    }
  );
  if (
    data.slaDetails.receipt.departmentSlaAssignmentList.length === 0 &&
    (data.receiptDetails[0].assigneeGroup !== null ||
      data.receiptDetails[0].assigneeGroup !== undefined)
  ) {
    rowsData.push({
      Receiver: 1,
      MasterArea: data.receiptDetails[0].assigneeGroup.assigneName,
      TargetDate: generateAppropriateDate(data.receiptDetails[0].targetTime),
    });
  }

  if (!data || !data.slaDetails) {
    return <p>{t("general.label.no.slaDetails")}.</p>;
  }

  return (
    // <div>
    //   {data.slaDetails.receipt.departmentSlaAssignmentList && (
    //     <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
    //       <Table>
    //         <TableHead>
    //           <TableRow style={{ backgroundColor: '#867FA1'  }}>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.step.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.assignName.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('menu.key.master.targettime')}</TableCell>
    //           </TableRow>
    //         </TableHead>
    //         <TableBody>
    //           {data.slaDetails.receipt.departmentSlaAssignmentList.map((optiondata, index) => (
    //             <TableRow key={index}>
    //               <TableCell>{index + 1}</TableCell>
    //               <TableCell>{optiondata.assigneeName}</TableCell>
    //               <TableCell>{generateAppropriateDate(optiondata.targetTime)}</TableCell>
    //             </TableRow>
    //           ))}
    //         </TableBody>
    //       </Table>
    //     </TableContainer>
    //   )}

    //   {data.slaDetails.receipt.departmentSlaEscalationList &&
    //     data.slaDetails.receipt.departmentSlaEscalationList.length > 0 && (
    //       <TableContainer component={Paper}>
    //         <Table>
    //           <TableHead>
    //             <TableRow style={{ backgroundColor: '#867FA1'  }}>
    //               <TableCell  className={styles.tableHeight} >{t('general.label.escalation.step')}</TableCell>
    //               <TableCell  className={styles.tableHeight}>{t('general.label.assignee.name.group')}</TableCell>
    //               <TableCell  className={styles.tableHeight}>{t('general.label.escalation.time')}</TableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             {data.slaDetails.receipt.departmentSlaEscalationList.map((escalationdata, index) => (
    //               <TableRow key={index}>
    //                 <TableCell>{escalationdata.escalationStep}</TableCell>
    //                 <TableCell>
    //                   {escalationdata.asigneeId !== 0 ? (
    //                     escalationdata.assigneeName
    //                   ) : (
    //                     <>
    //                       {escalationdata.assigneeGroupName}{' '}
    //                       <i className="fa fa-share-square-o"></i>
    //                     </>
    //                   )}
    //                 </TableCell>
    //                 <TableCell>{generateAppropriateDate(escalationdata.escTime)}</TableCell>
    //               </TableRow>
    //             ))}
    //           </TableBody>
    //         </Table>
    //       </TableContainer>
    //     )}
    // </div>
    // <Card className='overflow-hidden'>

    //   <Card.Body>
    //   {t('feedbackDetails.resolutionTarget.text')}:
    //     <DatatTable tableStyles={tableStyles} tableData={{ columnData: columnData, rowsData: rowsData }} />
    //    {t('feedbackDetails.escalationMatrix.text')}:
    //     <DatatTable tableStyles={tableStyles} tableData={{ columnData: columnData1, rowsData: rowsData1 }} />
    //   </Card.Body>
    // </Card>

    <Col lg="12">
      <Card className="mb-3 overflow-hidden">
        <Card.Header className="light-blue-bg fw-medium">
          {t("feedbackDetails.resolutionTarget.text")}
        </Card.Header>
        <Card.Body className="p-0">
          <DatatTable
            tableStyles={tableStyles}
            tableData={{ columnData: columnData, rowsData: rowsData }}
          />
        </Card.Body>
      </Card>
      <Card className="mb-3 overflow-hidden">
        <Card.Header className="light-blue-bg fw-medium">
          {t("feedbackDetails.escalationMatrix.text")}
        </Card.Header>
        <Card.Body className="p-0">
          <DatatTable
            tableStyles={tableStyles}
            tableData={{ columnData: columnData1, rowsData: rowsData1 }}
          />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default SlaDetails;
